import { toast } from "react-toastify";
import { API_INCIDENCIA_STATUS_LOGS, API_INCIDENCIAS } from "../../views/MainLayout/components/shared/services/incidencias";
import { asyncMac, makeAsyncTypes, makeFetchingReducer } from "../utils";

const initialFicha = { 
};

export const fichaReducer = (state = initialFicha, action) => {
    switch(action.type){
        case "incidencia/fullfilled": {
            const futureState = {...state, incidencia: action.payload};
            return futureState;
        }
        case "incidencia-steps/fullfilled": {
            const futureState = {...state, incidencia: {...state.incidencia, steps: action.payload}};
            return futureState;
        }
        case "incidencia/clear": {
            return {
                ...state,
                incidencia: null,
                logs: []
            }
        }
        default:
            return state
    }
}

const asyncIncidencia = makeAsyncTypes('incidencia');

const [setPending, setFullFilled, setError ] = asyncMac(asyncIncidencia);

const asyncIncidenciaSteps = makeAsyncTypes('incidencia-steps');

const [setPendingSteps, setFullFilledSteps, setErrorSteps ] = asyncMac(asyncIncidenciaSteps);

export const fichaFetchingReducer = makeFetchingReducer([
    'incidencia/pending', 
    'incidencia/fullfilled', 
    'incidencia/rejected'
]);

export const fichaFetchingStepsReducer = makeFetchingReducer([
    'incidencia-steps/pending', 
    'incidencia-steps/fullfilled', 
    'incidencia-steps/rejected'
]);

export const fetchIncidencia = (incidenciaId) => async dispatch => {
    dispatch(setPending());

    try {
        const response = await API_INCIDENCIAS.getIncidencia(incidenciaId)
        const data = await response.data;
        dispatch(setFullFilled(data));
    } catch (e) {
        dispatch(setError(e.message))
    }
}

export const newIncidenciaSteps = (steps) => async dispatch => {
    dispatch(setPendingSteps());

    try {
        const response = await API_INCIDENCIA_STATUS_LOGS.newStepsLogs(steps)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilledSteps(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        dispatch(setErrorSteps(e.message))
    }
}

export const addDocumentationIncidencia = (incidenciaId, documentos) => async dispatch => {
    try {
        const response = await API_INCIDENCIAS.uploadDocuments(incidenciaId, documentos)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilled(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        dispatch(setError(e.message))
        toast.error(e.message);
    }
}

export const deleteDocumentationIncidencia = (incidenciaId, documento) => async dispatch => {
    try {
        const response = await API_INCIDENCIAS.deleteIncidenciaFile(incidenciaId, documento)
        const data = await response.data;
        toast.success(response.message);
        dispatch(setFullFilled(data));
        dispatch({type: 'loading/set', payload: false});
    } catch (e) {
        dispatch(setError(e.message))
        toast.error(e.message);
    }
}

export const fichaIncidenciaReducer = fichaReducer;
export const currentIncidenciaStatusReducer = fichaFetchingReducer;